import { CurrencySelector } from "@/src/components"
import { Card, CardContent, CardHeader, Divider, Grid, IconButton, Stack } from "@mui/material"
import { BooleanInput, DateTimeInput, NumberInput, ReferenceInput, SaveButton, SelectInput, TextInput, Toolbar, useInput } from "react-admin"
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
export const SectionUserEditCredits = () => {

    return (
        <Card variant="outlined">
            <CardHeader title={"Credits"} />
            <CardContent>

                <Stack direction={"row"} spacing={1}>

                    <NumberInput variant="outlined" source="wallet.credits"
                        label="Credits" helperText={false}
                        fullWidth />

                    <NumberInput variant="outlined" source="wallet.rewards"
                        label="Rewards" helperText={false}
                        fullWidth />

                </Stack>

                <DateTimeInput variant="outlined" source="boosted"
                    label="Boosted at" helperText={false}
                    fullWidth />

            </CardContent>
            <SectioinUserEditPremium />
            <Toolbar
            // {...sanitizeToolbarProps(formProps)}
            >
                <SaveButton label="Save" />
            </Toolbar>
        </Card>
    )
}




const SectioinUserEditPremium = () => {

    const { field: premiumField } = useInput({ source: "premium", })

    return (
        <>
            <CardHeader title={"Premium"} />
            <CardContent>
                {!premiumField.value && <IconButton onClick={() => premiumField.onChange({})}><AddBoxOutlinedIcon /></IconButton>}
                {premiumField.value && <IconButton color="error" onClick={() => premiumField.onChange(null)}><DeleteForeverOutlinedIcon /></IconButton>}
                {premiumField.value &&
                    <Grid container spacing={1}>

                        <Grid size={{ xs: 12, sm: 6, xl: 6 }} >
                            <Grid size={6}>
                                <BooleanInput source="premium.isActive" label="Is active"
                                    helperText={false} fullWidth readOnly
                                />
                            </Grid>
                            <Grid size={6}>
                                <BooleanInput variant="outlined" source="premium.willAutoRenew"
                                    label='Will Auto Renew' helperText={false}
                                    fullWidth />
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                            <ReferenceInput variant="outlined" label="Plan"
                                source="premium.product" helperText={false}
                                reference="SubscriptionProduct" fullWidth>
                                <SelectInput optionText="title" />
                            </ReferenceInput>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                            <DateTimeInput variant="outlined" source="premium.purchasedAt"
                                label='Purchased at' helperText={false}
                                fullWidth />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, xl: 6 }}>

                            <DateTimeInput variant="outlined" source="premium.expiresAt"
                                label='Expires at' helperText={false} fullWidth />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                            <NumberInput variant="outlined" source="premium.price"
                                label='Price' helperText={false}
                                fullWidth />


                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                            <CurrencySelector variant="outlined" source="premium.currency"
                                label='Currency' helperText={false}
                                fullWidth />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                            <TextInput variant="outlined" source="premium.provider" readOnly
                                label='Provider' helperText={false}
                                fullWidth />
                        </Grid>
                        <Divider />

                    </Grid>
                }
            </CardContent>
        </>
    )
}